import React, { useState, useEffect } from "react";

const NEW_OPTION_VALUE = "__new__";

/**
 * Select de tipo de caixa com sugestões (valores já usados noutros produtos)
 * e opção para criar um tipo novo digitando um texto livre.
 */
const BoxTypeSelect = ({ id, label, value, onChange, options }) => {
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    if (value && !options.includes(value)) {
      setIsCreating(true);
    }
  }, [value, options]);

  const handleSelectChange = (e) => {
    const selected = e.target.value;
    if (selected === NEW_OPTION_VALUE) {
      setIsCreating(true);
      onChange("");
    } else {
      setIsCreating(false);
      onChange(selected);
    }
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm text-neutral-700 mb-2">
        {label}
      </label>
      {isCreating ? (
        <div className="flex gap-2">
          <input
            id={id}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Novo tipo de caixa"
            className="w-full px-4 py-2 border border-neutral-200 rounded-lg"
          />
          {options.length > 0 && (
            <button
              type="button"
              onClick={() => {
                setIsCreating(false);
                onChange("");
              }}
              className="px-3 py-2 text-sm text-neutral-600 border border-neutral-200 rounded-lg whitespace-nowrap"
            >
              Cancelar
            </button>
          )}
        </div>
      ) : (
        <select
          id={id}
          value={value || ""}
          onChange={handleSelectChange}
          className="w-full px-4 py-2 border border-neutral-200 rounded-lg"
        >
          <option value="">Selecionar tipo de caixa</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
          <option value={NEW_OPTION_VALUE}>+ Criar novo tipo de caixa</option>
        </select>
      )}
    </div>
  );
};

export default BoxTypeSelect;
